import type { WhatWeGoForSpiel } from "./types";

export const whatWeGoFor: WhatWeGoForSpiel = {
  heading: "What we go for",
  items: [
    "Startups and growth-stage companies that want real engineering discipline without an enterprise-sized team.",
    "Teams that need one crew across engineering, UI/UX, QA, and customer support — without building a department to get it.",
    "Companies that value fast iteration and continuous delivery.",
  ],
};
